<script setup lang="ts">
import { CheckCircleIcon } from '@heroicons/vue/20/solid'
import type { MarketingPreviewType } from '~/types/marketing'

const props = defineProps<{
  eyebrow: string
  title: string
  description: string
  bullets: string[]
  page: string
  previewType: MarketingPreviewType
  previewSrc?: string
  previewAlt: string
  previewCaption: string
}>()

const sectionElement = ref<HTMLElement | null>(null)
useMarketingSectionView({ page: props.page, section: 'hero', target: sectionElement })
</script>

<template>
  <section ref="sectionElement" class="relative isolate overflow-hidden bg-slate-950 py-20 sm:py-24">
    <div class="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_15%_20%,rgba(49,141,231,0.25),transparent_32%),radial-gradient(circle_at_90%_75%,rgba(106,168,79,0.13),transparent_28%)]" />
    <div class="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <div>
        <p class="inline-flex items-center gap-2 text-sm font-semibold text-sky-blue-300"><span class="h-px w-6 bg-sky-blue-300/70" aria-hidden="true" />{{ eyebrow }}</p>
        <h1 class="mt-5 text-balance text-4xl font-bold tracking-[-0.025em] text-white sm:text-5xl lg:text-[3.4rem] lg:leading-[1.08]">{{ title }}</h1>
        <p class="mt-6 text-pretty text-lg leading-8 text-slate-300">{{ description }}</p>
        <ul class="mt-7 space-y-3 text-sm leading-6 text-slate-300">
          <li v-for="bullet in bullets" :key="bullet" class="flex gap-3"><CheckCircleIcon class="mt-1 h-4 w-4 shrink-0 text-green-cucumber-400" aria-hidden="true" />{{ bullet }}</li>
        </ul>
        <div class="mt-8 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
          <MarketingCta :page="page" section="hero" variant="light" class="w-full sm:w-auto" />
          <MarketingCta href="/#tarif" label="Voir l’offre complète" :page="page" section="hero" destination="anchor" variant="secondary" class="w-full sm:w-auto" />
        </div>
      </div>
      <MarketingProductPreview :type="previewType" :src="previewSrc" :alt="previewAlt" :caption="previewCaption" priority />
    </div>
  </section>
</template>
